import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, Redirect } from "react-router-dom";
import { toggleLoadingShahrzad } from "../redux/actions/layout";
import { updateProfile } from "../redux/actions/profile";
import Api from "../api/newApi";
import { Stack, Typography } from "@mui/material";

const loadercss = `.loader {
  border: 4px solid #C3CCE0; /* bg */
  border-top: 4px solid #00c19f; /* rotating border */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s cubic-bezier(0.6, 0.2, 0.4, 0.8) infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@keyframes spin {
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}`;

const Middleware = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const layout = useSelector((state) => state.layout);

  const [error, setError] = useState("");

  const query = new URLSearchParams(useLocation().search);

  const clearLocalStorageAndCookies = () => {
    localStorage.clear();
    sessionStorage.clear();
    Cookies.remove("token");
    Cookies.remove("refreshToken");
  };
  const shahrzadLogin = () => {
    clearLocalStorageAndCookies();

    const paramsArray = Array.from(query.keys());

    const service =
      paramsArray.find((item) => item.toLowerCase() === "servicetype") ||
      paramsArray.find((item) => item.toLowerCase() === "serviceid");

    const serviceType =
      query.get(service) === "10001" ? "school" : query.get(service);

    Api.Post("user/service/shahrzad", {
      text: query.get("token"),
      service: serviceType,
      url: window.location.href,
    })
      .then((res) => {
        if (res.data.Code === 200) {
          handleAfterLogin(res.data.Data, "shahrzad");
        }
      })
      .catch((err) => {
        setError(err?.response?.data?.Message + "");
      });
  };
  const splusLogin = () => {
    clearLocalStorageAndCookies();

    const token = query.get("token");
    const service = query.get("service");

    Api.Post("user/service/splus", {
      text: token,
      service,
    })
      .then((res) => {
        if (res.data.Code === 200) {
          handleAfterLogin(res.data.Data, "splus");
        }
      })
      .catch((err) => {
        setError(err?.response?.data?.Message + "");
      });
  };
  const handleAfterLogin = (response, service) => {
    if (!Cookies.get("token")) {
      dispatch(updateProfile(response.profile));
      Cookies.set("token", response.token, { expires: 365 });
      Cookies.set("refreshToken", response.refreshToken, {
        expires: 365,
      });
      localStorage.setItem("agent_service", service);
      dispatch(toggleLoadingShahrzad(false));
    }
  };

  useEffect(() => {
    if (query.get("token") && !layout.loadingShahrzad) {
      dispatch(toggleLoadingShahrzad(true));

      if (query.get("from") === "splus") {
        splusLogin();
      } else {
        shahrzadLogin();
      }
    }
  }, []);

  if (layout.loadingShahrzad) {
    return (
      <Stack>
        {error ? (
          <Typography variant="h4" margin={"auto"}>
            {error}
          </Typography>
        ) : (
          <>
            <style>{loadercss}</style>
            <div className="loader"></div>
          </>
        )}
      </Stack>
    );
  }
  if (!Cookies.get("token") && !query.get("token")) {
    return <Redirect to={{ pathname: "/auth", state: { from: location } }} />;
  }

  return error === "" ? <>{children}</> : <div className="loader"></div>;
};

export default Middleware;
